import Constant from '@/common/constant/Constant';
import { atom } from 'recoil';

export const selectedFormCsv = atom({
    key: 'selectedFormCsv',
    default: ''
});

export const mappingCsv = atom({
    key: 'mappingCsv',
    default: {}
});

export const handleStatusAtom = atom({
    key: 'handleStatusAtom',
    default: Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_INITIAL
});

export const isClosePanelCsvAtom = atom({
    key: 'isClosePanelCsvAtom',
    default: false
});
